import { createGlobalStyle } from "styled-components";
import { DesignTokens } from "../../styles/design-tokens";

const { colors, fonts, spacings } = DesignTokens;

const GlobalStyles = createGlobalStyle`
  body {
    color: ${colors.main.positive};
    font-size: ${fonts.sizes.base}px;
    font-family: ${fonts.sansSerif};
    background: ${colors.main.negative};
    line-height: ${fonts.lineHeight.base};
  }

  .ant-modal-confirm-content {
    padding-top: ${spacings.xsmall}px;
    padding-bottom: ${spacings.small}px;
  }
  
  /* Make all AntD primary colors red */
  .ant-btn-primary {
    background-color: ${colors.main.primary} !important;
    border-color: ${colors.main.primary} !important;
  }

  .ant-btn-primary:hover,
  .ant-btn-primary:focus {
    background-color: #ff4d4f !important; /* lighter red for hover */
    border-color: #ff4d4f !important;
  }

 
`;

export { GlobalStyles };
